import * as React from "react";
const SvgFiRrLobster = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-lobster_svg__a)">
      <path
        fill="#062147"
        d="M23.08.39a.59.59 0 0 0-.58-.389.61.61 0 0 0-.543.361c-.306.665-.53 1.67-.957 2.574-.427-.904-.651-1.909-.957-2.574A.61.61 0 0 0 18.92.39C18.509 1.472 18.026 3.991 18 5c0 1.121.616 2.099 1.527 2.613A3 3 0 0 1 17 9h-1V5.8C16 3.035 13.906 0 12 0S8 3.035 8 5.8V9H7a3 3 0 0 1-2.527-1.387A3 3 0 0 0 6 5c0-.954-.498-3.498-.92-4.61-.193-.508-.897-.522-1.123-.029-.306.665-.53 1.67-.957 2.574-.427-.904-.651-1.909-.957-2.574C1.816-.132 1.112-.118.92.39.498 1.502 0 4.046 0 5a3 3 0 0 0 2.391 2.938A5.01 5.01 0 0 0 7 11h1v2h-.843a4.97 4.97 0 0 0-3.536 1.465l-.828.828a.999.999 0 1 0 1.414 1.414l.828-.828A2.98 2.98 0 0 1 7.157 15H8v3.515l-1.398 1.398c-.498.497-.603 1.021-.603 1.372 0 .537.235 1.057.681 1.502 1.079 1.08 3.377 1.863 5.319.581a3.97 3.97 0 0 0 2.213.665c1.257 0 2.425-.563 3.106-1.246.445-.445.681-.965.681-1.502 0-.352-.104-.875-.602-1.371l-1.399-1.399V15h.843c.802 0 1.556.312 2.122.879l.828.828a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414l-.828-.828A4.97 4.97 0 0 0 16.841 13h-.843v-2h1c2.07 0 3.85-1.265 4.609-3.062A3 3 0 0 0 23.998 5c-.026-1.009-.509-3.528-.92-4.61zM10 5.8c0-1.957 1.517-3.74 1.992-3.8C12.483 2.06 14 3.843 14 5.8V9h-4zm0 5.2h4v2h-4zm0 4h4v2h-4zm2.707 6.373a.997.997 0 0 0-1.414 0c-1.327 1.329-2.919.272-3.257-.065L10.344 19h3.312l2.307 2.311c-.338.337-1.926 1.391-3.255.062z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-lobster_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLobster;
